var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogoIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.36139e-07 18.1364L0.407079 34.9773L34.0451 1.4033L16.8149 0.996997L0.132923 17.6472L0.0166147 17.7633C0.0166147 17.7633 -7.35052e-07 18.1613 -7.36139e-07 18.1364Z",
    fill: "url(#paint0_linear_461_591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2782 18.1363L50.2782 34.5709L16.6401 0.996929L33.4633 0.996928L50.1453 17.6471L50.2616 17.7632C50.2616 17.7632 50.2782 18.1612 50.2782 18.1363Z",
    fill: "url(#paint1_linear_461_591)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000975813 34.2642L0.000975095 17.8296L33.639 51.4119L16.8158 51.4119L0.1339 34.7617L0.0175913 34.6456C0.0175913 34.6373 0.000975812 34.2476 0.000975813 34.2642Z",
    fill: "url(#paint2_linear_461_591)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2787 34.2642L50.2787 17.8296L37.6094 30.4831L30.6392 37.44L16.6406 51.4119L33.4638 51.4119L50.1457 34.7617L50.2621 34.6456C50.2621 34.6373 50.2787 34.2476 50.2787 34.2642Z",
    fill: "url(#paint3_linear_461_591)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_591",
    x1: 26.8484,
    y1: 7.4778,
    x2: -12.9102,
    y2: 30.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#FFC804"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_461_591",
    x1: 33.4597,
    y1: 34.568,
    x2: 33.4597,
    y2: 0.992037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_461_591",
    x1: 16.8198,
    y1: 17.836,
    x2: 16.8198,
    y2: 51.4119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6704,
    stopColor: "#70CA19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_461_591",
    x1: 33.4601,
    y1: 17.836,
    x2: 33.4601,
    y2: 51.4119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF151E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoIcon1);
export default __webpack_public_path__ + "static/media/header-logo-icon-1.aa131c8f.svg";
export { ForwardRef as ReactComponent };